<template>
	<div class="product-details-popup">
		<transition name="right-slide" v-on:after-leave="clearCartItemId">
			<div
				v-show="cartItemId"
				class="product-details-wrap"
				:class="{ 'is-loading': !productLoaded }"
			>
				<product-details-not-found v-if="!hasProduct" :is-incorrect-id="true" />
				<edit-product-popup
					v-if="currentCartItemId"
					@set-product-error="setProductError"
					@set-has-images="setHasImages"
					@hide="hideProductDetails"
					@update-cart="updateCart"
					@product-loaded="productLoaded = true"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div v-if="cartItemId" class="overlay" @click="hideProductDetails" />
		</transition>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import EditProductPopup from './EditProductPopup.vue'
import ProductDetailsNotFound from '../ProductDetailsNotFound'

export default {
	name: 'EditProductDetailsPopup',

	components: {
		EditProductPopup,
		ProductDetailsNotFound
	},

	data() {
		return {
			currentCartItemId: false,
			hasActiveProductImage: true,
			hasProductDetailsError: false,
			productLoaded: false,
			swiperOption: {
				slidesPerView: 1,
				spaceBetween: 0
			}
		}
	},

	mounted() {
		this.body = document.querySelector('body')

		if (this.cartItemId) {
			this.body.style.overflow = 'hidden'
			this.currentCartItemId = this.cartItemId
		}
	},

	beforeDestroy() {
		this.body.style.overflow = 'visible'
	},

	computed: {
		...mapState('cart', ['cartItems']),

		cartItemId() {
			return this.$route.query.productId
		},

		hasProduct() {
			return this.cartItems?.some(
				product => product.id === this.currentCartItemId
			)
		}
	},

	watch: {
		async cartItemId(id) {
			if (id) {
				this.body.style.overflow = 'hidden'
				this.currentCartItemId = this.cartItemId
			} else {
				this.body.style.overflow = 'visible'
			}
		}
	},

	methods: {
		clearCartItemId() {
			this.currentCartItemId = null
		},

		setProductError(val) {
			this.hasProductDetailsError = val
		},

		setHasImages(val) {
			this.hasActiveProductImage = val
		},

		updateCart() {
			this.$emit('update-cart')
		},

		hideProductDetails() {
			const newQuery = JSON.parse(JSON.stringify(this.$route.query))

			delete newQuery.productId

			this.$router
				.push({
					...this.$route,
					query: newQuery
				})
				.catch(() => {})

			this.productLoaded = false
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.product-details-popup {
	/deep/ .product-details-price {
		font-size: 20px;
	}

	/deep/ .product-details-alt-price {
		font-size: 16px;
		font-weight: 700;
		color: $grey;
	}
}
</style>
